// components/UploadPaymentProof.js
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/orderconf.css";
import Navbar from "./common/Navbar.jsx";
import Footer from "./common/Footer.jsx";

const UploadPaymentProof = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      setError("");
    } else {
      setError("Please select a valid image file");
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError("Please select a file first");
      return;
    }

    setIsUploading(true);
    setError("");

    try {
      const token = localStorage.getItem("clientToken");
      const formData = new FormData();
      formData.append("paymentProof", selectedFile);

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/orders/${orderId}/payment-proof`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Upload failed");
      }

      const result = await response.json();
      alert("Payment proof uploaded successfully!");
      navigate("/my-orders");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="upload-payment-container">
        <div className="upload-card">
          <div className="upload-header">
            <h1>
              <i className="fa-solid fa-upload"></i> Upload Payment Proof
            </h1>
            <p>For Order #: {orderId}</p>
          </div>

          <div className="upload-content">
            <div className="upload-instructions">
              <h3>Instructions:</h3>
              <ul>
                <li>Upload a clear photo of your payment receipt</li>
                <li>Ensure the amount and transaction details are visible</li>
                <li>Supported formats: JPG, PNG, GIF</li>
                <li>Maximum file size: 5MB</li>
              </ul>
            </div>

            <div className="file-upload">
              <input
                type="file"
                id="paymentProof"
                accept="image/*"
                onChange={handleFileSelect}
                className="file-input"
              />
              <label htmlFor="paymentProof" className="file-label">
                <i className="fa-solid fa-cloud-upload-alt"></i>
                {selectedFile ? selectedFile.name : "Choose an image file"}
              </label>

              {selectedFile && (
                <div className="file-preview">
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Payment proof preview"
                    className="preview-image"
                  />
                </div>
              )}
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="upload-actions">
              <button
                onClick={handleUpload}
                disabled={!selectedFile || isUploading}
                className="upload-btn"
              >
                {isUploading ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin"></i> Uploading...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-upload"></i> Upload Proof
                  </>
                )}
              </button>
              <button
                onClick={() => navigate("/my-orders")}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UploadPaymentProof;
